import { RichContentInput } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/es/format-message';
import { featureOn } from './featureCheck';
export var propsForInteractionEdit = function propsForInteractionEdit(props, additionalOptions) {
  var item = props.workingItem.toJS();
  var changeItemState = function changeItemState(newState, inputId) {
    props.clearValidationErrorsFromApi && props.clearValidationErrorsFromApi(inputId);
    props.changeItemState(item.id, newState);
  };
  var mediaUpload = function mediaUpload(file, callback) {
    var onUploadError = function onUploadError() {
      props.addError(t('There was an error uploading your file.'));
    };
    props.interactionFileUpload(props.parentType, props.parentId, file, callback, onUploadError);
  };
  var onModalOpen = function onModalOpen() {
    props.occludeQuizEntries(true);
  };
  var onModalClose = function onModalClose() {
    props.occludeQuizEntries(false);
  };
  var setOneQuestionAtATime = function setOneQuestionAtATime(event) {
    return props.setOneQuestionAtATime(props.quizId, event.target.checked);
  };
  return {
    additionalOptions: additionalOptions,
    answerFeedbackEnabled: props.answerFeedbackEnabled,
    answerFeedback: item.answerFeedback,
    appContainer: props.appContainer,
    changeItemState: changeItemState,
    errors: props.workingItem.getErrors().toJS(),
    validationErrorsFromApi: props.validationErrorsFromApi,
    errorsAreShowing: props.errorsAreShowing,
    fitbCommonWordbankEnabled: props.fitbCommonWordbankEnabled,
    interactionData: item.interactionData,
    interactionType: props.entry.getInteractionType(),
    // SHIM: canvas-rce breaks on null values now
    // this is a shim until canvas-rce deals with
    // null values better
    itemBody: item.itemBody || '',
    itemId: item.id,
    mediaUpload: mediaUpload,
    notifyScreenreader: props.screenreaderNotification,
    onModalOpen: onModalOpen,
    onModalClose: onModalClose,
    oneQuestionAtATime: props.oneQuestionAtATime,
    openImportModal: props.openImportModal,
    parentType: props.parentType,
    partialDeepScoringEnabled: props.partialDeepScoringEnabled,
    partialScoringEnabled: props.partialScoringEnabled,
    pointsChange: props.handleQuizEntryPointsChange,
    properties: item.properties,
    override: props.override,
    overrideEditableForItem: props.overrideEditableForItem,
    overrideEditableForRegrading: props.overrideEditableForRegrading,
    richContentEditor: RichContentInput,
    scoringAlgorithm: item.scoringAlgorithm,
    scoringData: item.scoringData,
    setOneQuestionAtATime: setOneQuestionAtATime,
    stemErrors: props.workingItem.errorsFor('itemBody').toJS(),
    initialFocusId: props.initialFocusId,
    calculatorType: item.calculatorType,
    multipleHotSpotEnabled: featureOn('multiple_hotspot_selections')
  };
};
export var propsForInteractionShow = function propsForInteractionShow(item) {
  return {
    itemId: item.id,
    interactionData: item.interactionData,
    // SHIM: canvas-rce breaks on null values now
    // this is a shim until canvas-rce deals with
    // null values better
    itemBody: item.itemBody || '',
    properties: item.properties,
    notifyScreenreader: true,
    scoringData: item.scoringData
  };
};